/**
 * Metering Actions
 *
 * Redux action types and creators for metering data flow.
 * Follows Redux async pattern: PENDING → FULFILLED or REJECTED
 *
 *  API Endpoints:
 *  Overview Contracted - Single object with contracted capacity details
 *  Table Details - Array of detailed capacity rows
 *  Contract table - Array of contracts
 *  Assets by customer
 *  Add asset
 *  Download csv
 */

// ============================================================================
// OVERVIEW API ACTIONS - Contracted Capacity Card
// ============================================================================
export const GET_METERING_OVERVIEW_CONTRACTED_PENDING =
  "GET_METERING_OVERVIEW_CONTRACTED_PENDING";
export const GET_METERING_OVERVIEW_CONTRACTED_REJECTED =
  "GET_METERING_OVERVIEW_CONTRACTED_REJECTED";
export const GET_METERING_OVERVIEW_CONTRACTED_FULFILLED =
  "GET_METERING_OVERVIEW_CONTRACTED_FULFILLED";

// ============================================================================
// TABLE API ACTIONS - Details Tables
// ============================================================================

export const GET_METERING_TABLE_DETAILS_PENDING =
  "GET_METERING_TABLE_DETAILS_PENDING";
export const GET_METERING_TABLE_DETAILS_REJECTED =
  "GET_METERING_TABLE_DETAILS_REJECTED";
export const GET_METERING_TABLE_DETAILS_FULFILLED =
  "GET_METERING_TABLE_DETAILS_FULFILLED";

// Contract table
export const GET_METERING_TABLE_CONTRACTS_PENDING =
  "GET_METERING_TABLE_CONTRACTS_PENDING";
export const GET_METERING_TABLE_CONTRACTS_REJECTED =
  "GET_METERING_TABLE_CONTRACTS_REJECTED";
export const GET_METERING_TABLE_CONTRACTS_FULFILLED =
  "GET_METERING_TABLE_CONTRACTS_FULFILLED";

// Get Customer Contracts for Add Assets Slider
export const GET_METERING_CONTRACTS_BY_CUSTOMER_PENDING =
  "GET_METERING_CONTRACTS_BY_CUSTOMER_PENDING";
export const GET_METERING_CONTRACTS_BY_CUSTOMER_REJECTED =
  "GET_METERING_CONTRACTS_BY_CUSTOMER_REJECTED";
export const GET_METERING_CONTRACTS_BY_CUSTOMER_FULFILLED =
  "GET_METERING_CONTRACTS_BY_CUSTOMER_FULFILLED";

// Add Assets
export const CREATE_ADD_METERING_ASSETS_PENDING =
  "CREATE_ADD_METERING_ASSETS_PENDING";
export const CREATE_ADD_METERING_ASSETS_REJECTED =
  "CREATE_ADD_METERING_ASSETS_REJECTED";
export const CREATE_ADD_METERING_ASSETS_FULFILLED =
  "CREATE_ADD_METERING_ASSETS_FULFILLED";

//Capacity details table  csv download
export const GET_METERING_CAPACITY_CSV_DOWNLOAD_PENDING =
  "GET_METERING_CAPACITY_CSV_DOWNLOAD_PENDING";
export const GET_METERING_CAPACITY_CSV_DOWNLOAD_REJECTED =
  "GET_METERING_CAPACITY_CSV_DOWNLOAD_REJECTED";
export const GET_METERING_CAPACITY_CSV_DOWNLOAD_FULFILLED =
  "GET_METERING_CAPACITY_CSV_DOWNLOAD_FULFILLED";

// Contracts table csv download
export const GET_METERING_CONTRACTS_CSV_DOWNLOAD_PENDING =
  "GET_METERING_CONTRACTS_CSV_DOWNLOAD_PENDING";
export const GET_METERING_CONTRACTS_CSV_DOWNLOAD_REJECTED =
  "GET_METERING_CONTRACTS_CSV_DOWNLOAD_REJECTED";
export const GET_METERING_CONTRACTS_CSV_DOWNLOAD_FULFILLED =
  "GET_METERING_CAPACITY_CSV_DOWNLOAD_FULFILLED";

export const getMeteringOverviewContractedPending = payload => ({
  type: GET_METERING_OVERVIEW_CONTRACTED_PENDING,
  payload
});

export const getMeteringOverviewContractedRejected = payload => ({
  type: GET_METERING_OVERVIEW_CONTRACTED_REJECTED,
  payload
});

export const getMeteringOverviewContractedFulfilled = payload => ({
  type: GET_METERING_OVERVIEW_CONTRACTED_FULFILLED,
  payload
});

export const getMeteringTableDetailsPending = payload => ({
  type: GET_METERING_TABLE_DETAILS_PENDING,
  payload
});

export const getMeteringTableDetailsRejected = payload => ({
  type: GET_METERING_TABLE_DETAILS_REJECTED,
  payload
});

export const getMeteringTableDetailsFulfilled = payload => ({
  type: GET_METERING_TABLE_DETAILS_FULFILLED,
  payload
});

export const getMeteringTableContractsPending = () => ({
  type: GET_METERING_TABLE_CONTRACTS_PENDING
});

export const getMeteringTableContractsRejected = payload => ({
  type: GET_METERING_TABLE_CONTRACTS_REJECTED,
  payload
});

export const getMeteringTableContractsFulfilled = payload => ({
  type: GET_METERING_TABLE_CONTRACTS_FULFILLED,
  payload
});

export const getMeteringContractsByCustomerPending = () => ({
  type: GET_METERING_CONTRACTS_BY_CUSTOMER_PENDING
});

export const getMeteringContractsByCustomerRejected = payload => ({
  type: GET_METERING_CONTRACTS_BY_CUSTOMER_REJECTED,
  payload
});

export const getMeteringContractsByCustomerFulfilled = payload => ({
  type: GET_METERING_CONTRACTS_BY_CUSTOMER_FULFILLED,
  payload
});

export const addMeteringAssetsPending = assets => ({
  type: CREATE_ADD_METERING_ASSETS_PENDING,
  payload: assets
});

export const addMeteringAssetsRejected = error => ({
  type: CREATE_ADD_METERING_ASSETS_REJECTED,
  payload: error
});

export const addMeteringAssetsFulfilled = payload => {
  return {
    type: CREATE_ADD_METERING_ASSETS_FULFILLED,
    payload
  };
};

export const getMeteringCapacityCSVDownloadPending = payload => ({
  type: GET_METERING_CAPACITY_CSV_DOWNLOAD_PENDING,
  payload
});

export const getMeteringCapacityCSVDownloadRejected = error => ({
  type: GET_METERING_CAPACITY_CSV_DOWNLOAD_REJECTED,
  error
});

export const getMeteringCapacityCSVDownloadFulfilled = payload => ({
  type: GET_METERING_CAPACITY_CSV_DOWNLOAD_FULFILLED,
  payload
});

export const getMeteringContractsCSVDownloadPending = payload => ({
  type: GET_METERING_CONTRACTS_CSV_DOWNLOAD_PENDING,
  payload
});

export const getMeteringContractsCSVDownloadRejected = error => ({
  type: GET_METERING_CONTRACTS_CSV_DOWNLOAD_REJECTED,
  error
});

export const getMeteringContractsCSVDownloadFulfilled = payload => ({
  type: GET_METERING_CONTRACTS_CSV_DOWNLOAD_FULFILLED,
  payload
});
